'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { shouldApplyMacOsTheme } from '@/lib/utils/should-apply-theme'

/**
 * macOSテーマのクラスを document.body に付け外しするコントローラー。
 *
 * - 社内ルートでは body.classList に "theme-macos" を追加
 * - 除外ルート（G-PLAN・ICぽちぽち・マイページ等）では削除
 * - アンマウント時にも削除（クリーンアップ）
 *
 * app/layout.tsx で <MacOsThemeController /> をレンダリングするだけで
 * Toaster・Dialog・Popover などの portal 系 UI にもテーマが継承される。
 */
export function MacOsThemeController() {
  const pathname = usePathname()

  useEffect(() => {
    const apply = shouldApplyMacOsTheme(pathname)
    if (apply) {
      document.body.classList.add('theme-macos')
    } else {
      document.body.classList.remove('theme-macos')
    }

    return () => {
      document.body.classList.remove('theme-macos')
    }
  }, [pathname])

  return null
}
